export * from './image-slider.component';
export * from './image-slider.module';



// WEBPACK FOOTER //
// ./src/app/shared/components/image/slider/index.ts